/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCredRequest
 */
export interface CreateCredRequest {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof CreateCredRequest
     */
    said: string;
    /**
     * SAID of the credential type - it is called Credential Schema
     * @type {string}
     * @memberof CreateCredRequest
     */
    schemaSaid: string;
    /**
     * AID of issuer - who created that credential
     * @type {string}
     * @memberof CreateCredRequest
     */
    issuerAid: string;
    /**
     * AID of credential holder
     * @type {string}
     * @memberof CreateCredRequest
     */
    holderAid: string;
    /**
     * Any additional credential details. Usually it is credentials cesr
     * @type {string}
     * @memberof CreateCredRequest
     */
    details?: string;
}

/**
 * Check if a given object implements the CreateCredRequest interface.
 */
export function instanceOfCreateCredRequest(value: object): boolean {
    if (!('said' in value)) return false;
    if (!('schemaSaid' in value)) return false;
    if (!('issuerAid' in value)) return false;
    if (!('holderAid' in value)) return false;
    return true;
}

export function CreateCredRequestFromJSON(json: any): CreateCredRequest {
    return CreateCredRequestFromJSONTyped(json, false);
}

export function CreateCredRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCredRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'],
        'schemaSaid': json['schemaSaid'],
        'issuerAid': json['issuerAid'],
        'holderAid': json['holderAid'],
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function CreateCredRequestToJSON(value?: CreateCredRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'schemaSaid': value['schemaSaid'],
        'issuerAid': value['issuerAid'],
        'holderAid': value['holderAid'],
        'details': value['details'],
    };
}

